import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import CustomerDashboard from './CustomerDashboard';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
  const { user } = useAuth();

  // Check if user has SYSTEM_CUSTOMER role
  const isCustomer = user?.systemRoles?.some(role => role.code === 'SYSTEM_CUSTOMER');

  if (isCustomer) {
    return <CustomerDashboard />;
  }

  return <AdminDashboard />;
};

export default Dashboard;
